import { Box, Button, Center } from '@chakra-ui/react';

export type ContinueButtonProps = {
  isDisabled: boolean;
  onClick?: () => void;
};

const ContinueButton = ({ isDisabled, onClick }: ContinueButtonProps) => {
  return (
    <Box position={'fixed'} bottom={'5'} width={'100%'} className="noScroll">
      <Center
        maxWidth={'480px'}
        border={'3px'}
        borderColor={'white'}
        paddingLeft={'7'}
        paddingRight={'7'}
      >
        <Button
          bg={isDisabled ? 'dripSecondaryFill' : 'tintColor'}
          color={'white'}
          borderRadius={'3xl'}
          onClick={onClick}
          width={'100%'}
          size={'lg'}
          boxShadow="lg"
          _hover={{}}
          _focus={{}}
          _active={{}}
        >
          Continue
        </Button>
      </Center>
    </Box>
  );
};

export default ContinueButton;
